module.exports = __webpack_public_path__ + "img/hand-scissors.ec93139c.svg";